import { Text, TextProps } from "@chakra-ui/layout";
import { motion } from "framer-motion";

export const MotionText = motion<TextProps>(Text);
